module.exports = __webpack_public_path__ + "static/proweek-trophy-96fd070365181e0e074bcd65d31bb928.png";